import React from "react";
import { useGetTeamsQuery } from "../../features/teams/teamApi";
import Error from "../ui/loaders/Error";
import GlobalLoader from "../ui/loaders/GlobalLoader";
import Teamitem from "./Teamitem";

const TeamList = () => {
  const { data: teams, isLoading, isError } = useGetTeamsQuery();

  if (isLoading) {
    return <GlobalLoader />;
  }
  if (isError) {
    return <Error />;
  }

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">
        {teams?.map((team) => (
          <Teamitem key={team.id} team={team} />
        ))}
      </div>
    </div>
  );
};

export default TeamList;
